import axios from 'axios';
import { store } from '../store/store';
import { clearAuthData } from '../store/slice/authSlice';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  config => {
    const token = store.getState().auth.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const message = error.response?.data?.message || '';

    const isAuthEndpoint =
      url.includes('/login') || url.includes('/register') || url.includes('/forgot-password');

    if (status === 401 && !isAuthEndpoint && message.toLowerCase().includes('token')) {
      store.dispatch(clearAuthData());
      toast.error('Session expired. Please login again.');
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export default api;
